import { useEffect } from 'react';

const setMeta = (selector, attr, value) => {
  if (!value) return;
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [name, key] = selector.replace(/[[\]"']/g, '').split('=');
    if (key) {
      el.setAttribute(name === 'meta' ? 'name' : name, key);
    } else if (selector.includes('property=')) {
      const prop = selector.match(/property=["']?([^"'\]]+)/)?.[1];
      if (prop) el.setAttribute('property', prop);
    } else if (selector.includes('name=')) {
      const nm = selector.match(/name=["']?([^"'\]]+)/)?.[1];
      if (nm) el.setAttribute('name', nm);
    }
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
};

/**
 * usePageMeta — sets document.title plus description and Open Graph tags.
 */
export const usePageMeta = ({ title, description, image, url }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let desc = document.head.querySelector('meta[name="description"]');
      if (!desc) {
        desc = document.createElement('meta');
        desc.setAttribute('name', 'description');
        document.head.appendChild(desc);
      }
      desc.setAttribute('content', description);
    }
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', description);
    setMeta('meta[property="og:image"]', 'content', image);
    setMeta('meta[property="og:type"]', 'content', 'website');
    setMeta('meta[property="og:url"]', 'content', url || window.location.href);
    setMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', description);
    setMeta('meta[name="twitter:image"]', 'content', image);
  }, [title, description, image, url]);
};

export default usePageMeta;
